import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${({ margin }) => (margin ? margin : '10px 0px 2px 0px')};
    padding: ${({ padding }) => (padding ? padding : '20px 24px')};
    position: relative;
    background: ${({ background }) =>
        background ? background : '#ffffff 0% 0% no-repeat padding-box'};
    width: ${({ width }) => (width ? width : 'cal(100%-20px)')};
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
`;
export const RowHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
`;

export const CardTitle = styled.div`
    font-family: AvenirNextWorld demi;
    color: #140f4b;
    font-size: 16px;
    padding: 1rem;
    text-transform: capitalize;
`;

export const ImageContainer = styled.img`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
    padding: 1rem;
`;
